enum RegistrationTypeEnum
{
    Registration = 1,
    Activation = 2,
    ResetPassword = 3,
}

export default RegistrationTypeEnum;